module.exports = __webpack_public_path__ + "img/speed_bounce_card.a6cff0e6.svg";